import moment from 'moment-timezone';

/**
 * Applies an authenticated user's language/locale preferences to i18next,
 * moment, and localStorage.
 *
 * Must run after EVERY successful authentication - interactive login and
 * silent session restore (page refresh) alike. App bootstrap unconditionally
 * imports 'moment/locale/es-us', which activates it as moment's default
 * locale as a side effect of the import itself, before any user data loads.
 * Only calling this from the interactive login flow left the silent
 * session-restore path (SessionBootstrap, used on refresh) with no way to
 * ever correct that default back to the user's actual preference.
 *
 * @param {Object} userDetail
 * @param {Object} i18n - the i18next instance from useTranslation()
 */
const applyUserLocalePreferences = (userDetail, i18n) => {
  if (!userDetail || !userDetail.preferredLanguage) {
    return;
  }
  i18n.changeLanguage(userDetail.preferredLanguage.language);
  window.localStorage.setItem('userLocale', userDetail.preferredLanguage.language);
  moment.locale(userDetail.preferredLanguage.locale);
};

export default applyUserLocalePreferences;
